import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import RewardCenterPage from "./reward-center.page";
import {AccessRights} from "lib/constants/accessRights";
import LoadingComponent from "components/loading";
import { REWARD_CREATE_PAGE } from "modules/stockflow/config/stockflow.route";
import { useHistory } from "react-router-dom";
import {canAccess} from "../../../../profile/redux/selector/profile.selector";

function RewardCenterContainer() {
  const lang = useSelector(state => state.constant.languages);
  const hasStockflowViewAccessRight = useSelector(state =>
    canAccess(state, AccessRights.TrackcoPortal.REWARD_READ));
  const hasStockflowAddAccessRight = useSelector(state =>
    canAccess(state, AccessRights.TrackcoPortal.REWARD_CREATE));
  const history = useHistory();
  const [ activeIndex, setActiveIndex ] = useState(0)

  const handleNewReward = () => {
    history.push(REWARD_CREATE_PAGE)
  }

  const handleChange = (event, index) => {
    setActiveIndex(index)
  }

  useEffect(() => {
    if (!hasStockflowViewAccessRight) {
      history.push('/admin/dashboard')
    }
  }, [history, hasStockflowViewAccessRight])

  if (!hasStockflowViewAccessRight) return <LoadingComponent />;

  return (
    <RewardCenterPage
      hasStockflowAddAccessRight={hasStockflowAddAccessRight}
      handleNewReward={handleNewReward}
      activeIndex={activeIndex}
      handleChange={handleChange}
      lang={lang}
    />
  )
}

export default RewardCenterContainer;
